export type PaymentType = 'CASH' | 'UPI' | 'CARD' | 'CHEQUE' | 'OTHER';
export type TransactionType = 'CREDIT' | 'DEBIT' | 'YEARLY_FEE';
export type FeeType = 'TUITION_FEES' | 'ADMISSION_FEES' | 'TRANSPORT_FEES' | 'OTHER';

export const FEE_TYPES: FeeType[] = ['TUITION_FEES', 'ADMISSION_FEES', 'TRANSPORT_FEES', 'OTHER'];
